import React, { Component } from 'react';
import localization from '../localization/localization';
import './Events.css';

export default class Events extends Component {
  constructor(props) {
    super(props);
    this.state = {
      softOpening: process.env.PUBLIC_URL + '/media/alamakipyoraily_img.jpg',
      openingEvent: process.env.PUBLIC_URL + '/media/Avajaiset_2025.jpg',
      warmupEvent: process.env.PUBLIC_URL + '/media/LegitWeekend.jpg',
      aukiolot: process.env.PUBLIC_URL + '/media/Aukiolot.jpg',
      trainingEvent: process.env.PUBLIC_URL + '/media/verkkokauppa.jpg',
      advanced: process.env.PUBLIC_URL + '/media/AdvancedTraining.jpg',
      friendWed: process.env.PUBLIC_URL + '/media/maastopyoraily_img.jpg',
      seasonSale: process.env.PUBLIC_URL + '/media/SeasonSale.jpg',
      ruskaRace: process.env.PUBLIC_URL + '/media/RuskaRace.jpg',
      seasonEnder: process.env.PUBLIC_URL + '/media/SeasonEnder.jpg',
      Ruska: process.env.PUBLIC_URL + '/media/TBOFLogo1.png',
      mtbrally: process.env.PUBLIC_URL + '/media/alamakipyorailya_teijolla.jpg',
      mimmipaiva: process.env.PUBLIC_URL + '/media/Mimmipaiva2.jpg',
      juhannus: process.env.PUBLIC_URL + '/media/MtbRally2025.jpg',
      paattarit2026: process.env.PUBLIC_URL + '/media/Paattarit2026.jpg'
    }
  }

  render() {
    return (
      <div className="events-body">


        <div className="events-row">
          <div className="events-row-column">
            <div className="events-column-title">{localization.events.event2.title}</div>
            <div className="events-column-secondtitle">{localization.events.event2.secondtitle}</div>
            <div className="events-column-text">{localization.events.event2.description}</div>
          </div>
          <div className="events-row-column">
            <img className="events-column-img" alt="bgi" src={this.state.Ruska}></img>
          </div>
        </div>

        <div className="events-row">
          <div className="events-row-column">
            <div className="events-column-title">{localization.events.event3.title}</div>
            <div className="events-column-secondtitle">{localization.events.event3.secondtitle}</div>
            <div className="events-column-text">{localization.events.event3.description}</div>
          </div>
          <div className="events-row-column">
            <img className="events-column-img" alt="bgi" src={this.state.warmupEvent}></img>
          </div>
        </div>
        
        <div className="events-row">
          <div className="events-row-column">
            <div className="events-column-title">{localization.events.event13.title}</div>
            <div className="events-column-secondtitle">{localization.events.event13.secondtitle}</div>
            <div className="events-column-text">{localization.events.event13.description}</div>
          </div>
          <div className="events-row-column">
            <img className="events-column-img" alt="bgi" src={this.state.mimmipaiva}></img>
          </div>
        </div>

        <div className="events-row">
          <div className="events-row-column">
            <div className="events-column-title">{localization.events.event8.title}</div>
            <div className="events-column-secondtitle">{localization.events.event8.secondtitle}</div>
            <div className="events-column-text">{localization.events.event8.description}</div>
          </div>
          <div className="events-row-column">
            <img className="events-column-img" alt="bgi" src={this.state.juhannus}></img>
          </div>
        </div>

        <div className="events-row">
          <div className="events-row-column">
            <div className="events-column-title">{localization.events.event12.title}</div>
            <div className="events-column-secondtitle">{localization.events.event12.secondtitle}</div>
            <div className="events-column-text">{localization.events.event12.description}</div>
            <a className="events-column-link" href="https://www.mtbrally.com/fi">{localization.events.event12.link}</a>
          </div>
          <div className="events-row-column">
            <img className="events-column-img" alt="bgi" src={this.state.mtbrally}></img>
          </div>
        </div>

        <div className="events-row">
          <div className="events-row-column">
            <div className="events-column-title">{localization.events.event15.title}</div>
            <div className="events-column-secondtitle">{localization.events.event15.secondtitle}</div>
            <div className="events-column-text">{localization.events.event15.description}</div>
            <a className="events-column-link" href="https://www.instagram.com/meriteijobikepark/">{localization.events.event15.link}</a>
          </div>
          <div className="events-row-column">
            <img className="events-column-img" alt="bgi" src={this.state.paattarit2026}></img>
          </div>
        </div>
        
      </div>  
    );
  }
}